// Typelizer digest 451250d8c67d064478b2edc7ceb5580d
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /bank_connections/:provider/callback */
  show: (
    params: { provider: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/bank_connections/:provider/callback', params, options),
    method: 'get',
  }),
}
